// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import TECNotificationState, {
    TECNotificationFormState,
} from "@store/Framework/Store/Greif/Pages/TECNotification/TECNotificationState";
import { Draft } from "immer";

const initialState: TECNotificationState & TECNotificationFormState = {
    fieldValues: {},
};

const actions = {
    "Greif/Pages/TECNotification/SetCertificateId": (
        draft: Draft<TECNotificationState>,
        action: { certificateId: string },
    ) => {
        draft.certificateId = action.certificateId;
    },
    "Greif/Pages/TECNotification/ClearForm": (draft: Draft<TECNotificationFormState>) => {
        draft.fieldValues = {};
    },
    "Greif/Pages/TECNotification/SetFieldValue": (
        draft: Draft<TECNotificationFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifTECNotificationPagesActions = Parameters<typeof reducer>[1];
export default reducer;
